/**
 * Lo que quedó propio de este módulo.
 *
 * Los tres estados de bloque (cargando, roto, vacío) se mudaron a
 * `modules/comunes/estados`: eran seis archivos con tres nombres distintos para
 * el mismo componente. La rama de permiso que vivía acá tampoco era de Admin —
 * un 403 no se arregla reintentando en ninguna pantalla —, así que la regla es
 * ahora del componente compartido y lo único que sigue pasando este módulo es
 * qué decirle a quien no puede entrar.
 *
 * `SinDato` era la versión **de celda de tabla** del estado vacío —
 * `EmptyMetricState` mide una tarjeta y no entra en una fila de 32px — y por eso
 * se mudó a `src/ui` como `MissingCell`. Acá queda el alias, para no tocar los
 * tres call sites que ya lo nombran así.
 */
import type { ReactNode } from 'react'

export { MissingCell as SinDato, type MissingCellProps as SinDatoProps } from '../../ui'

/** Nota al pie de un bloque: de dónde sale lo que se acaba de leer. */
export function NotaFuente({ children }: { children: ReactNode }) {
  return <span className="text-micro text-muted-strong">{children}</span>
}
